document.addEventListener("DOMContentLoaded", function () {
  /* ----------------------------------------------------------------
   * 1. ELEMENT REFERENCES
   * ---------------------------------------------------------------- */
  const qtyInput     = document.getElementById("stickyQty");
  const plusBtn      = document.querySelector(".qty-btn.plus");
  const minusBtn     = document.querySelector(".qty-btn.minus");
  const addToCartBtn = document.getElementById("stickyAddToCart");
  const stickyCart   = document.getElementById("stickyCart");

  // ✅ ONLY the form inside .product__info-container
  //    (the page has 9 add-to-cart forms — this targets the right one)
  const productForm = document.querySelector(
    ".product__info-container form[action*='/cart/add']"
  );

  const mainQty        = document.querySelector('input[name="quantity"]');
  const mainAddBtn     = productForm?.querySelector('button[type="submit"]');
  const variantIdInput = productForm?.querySelector('input[name="id"]');

  const productInfoSection =
    productForm?.closest(".product__info-container") || productForm;

  // Bail out cleanly if the sticky UI or the correct form is missing
  if (!qtyInput || !plusBtn || !minusBtn || !addToCartBtn || !stickyCart) return;
  if (!productForm) return;

  /* ----------------------------------------------------------------
   * 2. CONSTANTS & STATE
   * ---------------------------------------------------------------- */
  const DEFAULT_LABEL     = window.stickyCartStrings?.defaultLabel || "Add to Cart";
  const CHOOSE_LABEL      = window.stickyCartStrings?.chooseLabel  || "Choose Color";
  const ADDED_LABEL       = window.stickyCartStrings?.addedLabel   || "Added ✓";
  const ADDING_LABEL      = window.stickyCartStrings?.addingLabel  || "Adding...";
  const ADDED_RESET_DELAY = 2000;         // ms shown for "Added ✓"
  const VISIBLE_CLASS     = "is-visible"; // class added when bar shows

  let addedTimeout = null;
  let isAdding     = false; // 🔒 true while an add-to-cart request is in flight

  /* ----------------------------------------------------------------
   * 3. STICKY BAR VISIBILITY
   *    Shows when the product form scrolls off the top.
   *    Also toggles the `is-visible` class.
   * ---------------------------------------------------------------- */
  function updateStickyVisibility() {
    if (!productForm) return;

    const rect     = productForm.getBoundingClientRect();
    const pastForm = rect.bottom < 0;
    const nextDisp = pastForm ? "flex" : "none";

    if (stickyCart.style.display !== nextDisp) {
      stickyCart.style.display = nextDisp;
    }

    if (pastForm) {
      if (!stickyCart.classList.contains(VISIBLE_CLASS)) {
        stickyCart.classList.add(VISIBLE_CLASS);
      }
      // Undo any inline styles the theme might use to hide it
      stickyCart.style.removeProperty("visibility");
      stickyCart.style.removeProperty("opacity");
      stickyCart.style.removeProperty("pointer-events");
    } else {
      if (stickyCart.classList.contains(VISIBLE_CLASS)) {
        stickyCart.classList.remove(VISIBLE_CLASS);
      }
    }
  }

  // Re-assert several times to fight theme race conditions
  function assertVisibilityBurst() {
    updateStickyVisibility();
    [50, 150, 300, 600, 1000].forEach((t) =>
      setTimeout(updateStickyVisibility, t)
    );
  }

  /* ----------------------------------------------------------------
   * 4. VARIANT DETECTION
   * ---------------------------------------------------------------- */
  function isVariantSelected() {
    if (mainAddBtn && mainAddBtn.disabled) return false;
    if (variantIdInput && !variantIdInput.value) return false;
    return true;
  }

  /* ----------------------------------------------------------------
   * 5. BUTTON STATE
   *    Always "Add to Cart" (or "Choose Color" when no variant selected).
   *    Blocked while an add is in flight or while "Added ✓" is showing.
   * ---------------------------------------------------------------- */
  function syncButtonState() {
    // Don't override during the "Added ✓" state or while adding
    if (addToCartBtn.dataset.state === "added") return;
    if (isAdding) return;

    if (isVariantSelected()) {
      addToCartBtn.disabled = false;
      addToCartBtn.textContent = DEFAULT_LABEL;
      addToCartBtn.dataset.state = "ready";
    } else {
      addToCartBtn.disabled = false;
      addToCartBtn.textContent = CHOOSE_LABEL;
      addToCartBtn.dataset.state = "choose";
    }
  }

  /* ----------------------------------------------------------------
   * 6. INITIAL CHECKS
   * ---------------------------------------------------------------- */
  syncButtonState();
  updateStickyVisibility();
  assertVisibilityBurst();
  window.addEventListener("load", assertVisibilityBurst);

  /* ----------------------------------------------------------------
   * 7. OBSERVERS — watch for variant / button state changes
   * ---------------------------------------------------------------- */
  if (mainAddBtn) {
    const btnObserver = new MutationObserver(syncButtonState);
    btnObserver.observe(mainAddBtn, {
      attributes: true,
      attributeFilter: ["disabled"],
      childList: true,
      characterData: true,
      subtree: true,
    });
  }

  if (variantIdInput) {
    variantIdInput.addEventListener("change", syncButtonState);
    const inputObserver = new MutationObserver(syncButtonState);
    inputObserver.observe(variantIdInput, {
      attributes: true,
      attributeFilter: ["value"],
    });
  }

  if (productForm) {
    productForm.addEventListener("click", () => setTimeout(syncButtonState, 50));
    productForm.addEventListener("change", () => setTimeout(syncButtonState, 50));
  }

  /* ----------------------------------------------------------------
   * 8. QUANTITY SYNC (two-way)
   *    sticky → main  AND  main → sticky
   * ---------------------------------------------------------------- */
  let isSyncingQty = false; // 🔒 prevents infinite ping-pong

  function syncQtyFromSticky(value) {
    if (isSyncingQty) return;
    isSyncingQty = true;

    if (mainQty) {
      mainQty.value = value;
      mainQty.dispatchEvent(new Event("input",  { bubbles: true }));
      mainQty.dispatchEvent(new Event("change", { bubbles: true }));
    }

    isSyncingQty = false;
  }

  function syncQtyFromMain(value) {
    if (isSyncingQty) return;
    if (parseInt(qtyInput.value) === parseInt(value)) return; // no change

    isSyncingQty = true;
    qtyInput.value = value;
    isSyncingQty = false;
  }

  // --- Sticky input controls ---
  plusBtn.addEventListener("click", () => {
    let val = parseInt(qtyInput.value) || 1;
    val++;
    qtyInput.value = val;
    syncQtyFromSticky(val);
  });

  minusBtn.addEventListener("click", () => {
    let val = parseInt(qtyInput.value) || 1;
    if (val > 1) {
      val--;
      qtyInput.value = val;
      syncQtyFromSticky(val);
    }
  });

  qtyInput.addEventListener("input", () => {
    let val = parseInt(qtyInput.value) || 1;
    if (val < 1) val = 1;
    qtyInput.value = val;
    syncQtyFromSticky(val);
  });

  // --- Main input → sticky ---
  if (mainQty) {
    mainQty.addEventListener("input", () => {
      let val = parseInt(mainQty.value) || 1;
      if (val < 1) val = 1;
      syncQtyFromMain(val);
    });

    mainQty.addEventListener("change", () => {
      let val = parseInt(mainQty.value) || 1;
      if (val < 1) val = 1;
      syncQtyFromMain(val);
    });

    // Watch the main input's `value` attribute — themes often change it
    // programmatically (variant change, +/- buttons) without firing events.
    const qtyObserver = new MutationObserver(() => {
      const val = parseInt(mainQty.value) || 1;
      syncQtyFromMain(val);
    });
    qtyObserver.observe(mainQty, {
      attributes: true,
      attributeFilter: ["value"],
    });

    // Initial sync on page load
    syncQtyFromMain(parseInt(mainQty.value) || 1);
  }

  /* ----------------------------------------------------------------
   * 9. "ADDED ✓" CONFIRMATION STATE
   * ---------------------------------------------------------------- */
  function showAddedState() {
    isAdding = false; // 🔓 unlock — the add succeeded

    addToCartBtn.dataset.state = "added";
    addToCartBtn.textContent = ADDED_LABEL;
    addToCartBtn.disabled = true;

    clearTimeout(addedTimeout);
    addedTimeout = setTimeout(() => {
      addToCartBtn.dataset.state = "ready";
      syncButtonState();
      assertVisibilityBurst();
    }, ADDED_RESET_DELAY);
  }

  /* ----------------------------------------------------------------
   * 10. WATCH CART MUTATIONS
   * ---------------------------------------------------------------- */
  const originalFetch = window.fetch;
  window.fetch = function (...args) {
    const request = args[0];
    const url = typeof request === "string" ? request : request?.url || "";
    const isAddToCart = url.includes("/cart/add");

    return originalFetch.apply(this, args).then(async (response) => {
      if (isAddToCart && response.ok) {
        showAddedState();
        assertVisibilityBurst();
      }
      return response;
    });
  };

  /* ----------------------------------------------------------------
   * 11. CART / DRAWER EVENTS — keep the bar visible
   * ---------------------------------------------------------------- */
  ["cart:updated", "cart:refresh", "cart:change"].forEach((ev) =>
    document.addEventListener(ev, assertVisibilityBurst)
  );

  const cartDrawer = document.querySelector("cart-drawer");
  if (cartDrawer) {
    cartDrawer.addEventListener("cart:updated", assertVisibilityBurst);
  }

  const cartDrawerItems =
    document.querySelector("cart-drawer-items") ||
    document.querySelector(".cart-drawer__items") ||
    document.querySelector("#CartDrawer");
  if (cartDrawerItems) {
    let drawerTimeout = null;
    const drawerObserver = new MutationObserver(() => {
      clearTimeout(drawerTimeout);
      drawerTimeout = setTimeout(assertVisibilityBurst, 150);
    });
    drawerObserver.observe(cartDrawerItems, {
      childList: true,
      subtree: true,
    });
  }

  document.addEventListener("click", (e) => {
    const t = e.target;
    if (
      t.closest("cart-drawer") ||
      t.closest(".cart-drawer") ||
      t.closest("[data-cart-drawer]") ||
      t.closest('a[href*="/cart"]')
    ) {
      assertVisibilityBurst();
    }
  });

  /* ----------------------------------------------------------------
   * 12. FIGHT BACK IF THE THEME HIDES THE BAR
   * ---------------------------------------------------------------- */
  const bodyObserver = new MutationObserver(() => {
    const rect = productForm?.getBoundingClientRect();
    if (rect && rect.bottom < 0) {
      updateStickyVisibility();
    }
  });
  bodyObserver.observe(document.body, {
    attributes: true,
    attributeFilter: ["class", "style"],
  });

  const stickyObserver = new MutationObserver(() => {
    const rect = productForm?.getBoundingClientRect();
    if (rect && rect.bottom < 0) {
      if (stickyCart.style.display === "none") {
        stickyCart.style.display = "flex";
      }
      if (!stickyCart.classList.contains(VISIBLE_CLASS)) {
        stickyCart.classList.add(VISIBLE_CLASS);
      }
    } else {
      if (stickyCart.classList.contains(VISIBLE_CLASS)) {
        stickyCart.classList.remove(VISIBLE_CLASS);
      }
    }
  });
  stickyObserver.observe(stickyCart, {
    attributes: true,
    attributeFilter: ["style", "class"],
  });

  /* ----------------------------------------------------------------
   * 13. STICKY ADD TO CART CLICK
   *     Locks the observer (isAdding) so the label doesn't flip
   *     to "Choose Color" while the theme disables the main button.
   * ---------------------------------------------------------------- */
  addToCartBtn.addEventListener("click", () => {
    // No variant selected yet → scroll to the product form
    if (addToCartBtn.dataset.state === "choose") {
      if (productInfoSection) {
        productInfoSection.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
      return;
    }

    if (!mainAddBtn || addToCartBtn.disabled) return;

    isAdding = true; // 🔒 lock the observer out

    addToCartBtn.disabled = true;
     const isFrench = document.documentElement.lang === "fr";
    addToCartBtn.textContent = isFrench ? "Ajout..." : "Adding...";

    mainAddBtn.click();
    assertVisibilityBurst();

    // Safety net: if the fetch never fires (non-AJAX form submit),
    // unlock after 5s and restore the normal state.
    setTimeout(() => {
      if (addToCartBtn.dataset.state !== "added") {
        isAdding = false;
        syncButtonState();
      }
    }, 5000);
  });

  /* ----------------------------------------------------------------
   * 14. SCROLL / RESIZE
   * ---------------------------------------------------------------- */
  window.addEventListener("scroll", updateStickyVisibility, { passive: true });
  window.addEventListener("resize", updateStickyVisibility);
});